import { useGlobalStore } from '../store';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';

type ParamsType = {
  path: string;
  query?: Record<string, any>;
};

/**
 * @description: 默认跳转方法，拼接currentCorpId&agentId&staffId
 * @param { ParamsType } 跳转参数
 * @return { toPath } 跳转函数
 */
export const useDefaultLink = () => {
  const router = useRouter();
  const route = useRoute();
  const globalStore = useGlobalStore();
  const { appData, firstEntryStaffId } = storeToRefs(globalStore);
  const staffId = route.query?.staffId || firstEntryStaffId?.value;
  const toPath = async (type: 'push' | 'replace', params: ParamsType) => {
    const { path, query: paramsQuery = {} } = params;
    const routerParams = {
      path,
      query: {
        currentCorpId: appData.value?.currentCorpId,
        agentId: appData.value?.agentId,
        staffId,
        ...paramsQuery,
      },
    };

    await router[type](routerParams).catch((err) => {});
  };

  return {
    toPath,
  };
};
